import { isPresent } from 'utils/isPresent';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import { getFormValues } from 'redux-form';
import DragIcon from 'housecall-ui/dist/IconsAndImages/Icons/Drag';
import ConsumerAppChip from '../../Common/ConsumerAppChip.jsx';
import Radio from 'housecall-ui/dist/DesignSystem/Inputs/RadioButtons/Radio';
import ProAppChip from '../../Common/ProAppChip.jsx';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import { ALLOW_ADDRESS_ROW_CLICK, CUSTOMER_INFO_FORM, UPDATE_BILLING_ADDRESS_INDEX } from './Redux/Actions';

const styles = (theme) => ({
  dragIcon: {
    color: theme.palette.secondary.main,
  },
});

@connect((state) => ({
  addressHashes: getFormValues(CUSTOMER_INFO_FORM)(state).service_addresses || [],
  housecallAddressHashes: getFormValues(CUSTOMER_INFO_FORM)(state).addresses || [],
  hasParent: isPresent((state.addOrEditCustomer.parentCustomer || {}).id),
}))
@withStyles(styles)
export default class AddressTitle extends PureComponent {
  renderBillingOrLabel() {
    const { isParent, isHousecall, index, hasParent, housecallAddressHashes } = this.props;
    if (isParent) {
      return <ProAppChip label="Parent billing address" />;
    } else if (isHousecall) {
      return <ConsumerAppChip label="Housecall app address" />;
    } else if (!hasParent && housecallAddressHashes.length < 1) {
      return <BillingAddressRadio index={index} />;
    }
  }

  canDragAndDropAddress() {
    const { isParent, isHousecall } = this.props;

    return !isParent && !isHousecall && isPresent(this.props.connectDragSource);
  }

  renderDragNDropSource(classes) {
    if (this.canDragAndDropAddress()) {
      return this.props.connectDragSource(
        <div>
          <DragIcon className={classes.dragIcon} />
        </div>
      );
    }
  }

  getAddress() {
    const { isHousecall, index, addressHashes, housecallAddressHashes } = this.props;

    if (isHousecall) {
      return housecallAddressHashes[index];
    } else {
      return addressHashes[index];
    }
  }

  render() {
    const { classes } = this.props;
    let address = this.getAddress() || {};

    return (
      <Grid container alignItems="center" style={{ paddingLeft: 8 }}>
        <Grid item xs={2} sm={1}>
          {this.renderDragNDropSource(classes)}
        </Grid>
        <Grid container item xs={10} sm={11} alignItems="center">
          <Grid item xs={12} sm={5}>
            <Typography variant="subtitle1">
              {address.street}
              {address.street_line_2 && <br />}
              {address.street_line_2}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} style={{ flex: 1 }}>
            <Typography variant="subtitle1">
              {isPresent(address.city) ? `${address.city},` : ''} {address.state} {address.zip}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            {this.renderBillingOrLabel()}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

@connect(
  (state) => ({
    billingAddressIndex: state.addOrEditCustomer.billingAddressIndex,
  }),
  (dispatch) => ({
    updateBillingAddress: (index) => {
      dispatch({ type: UPDATE_BILLING_ADDRESS_INDEX, index: index });
    },
    disableRowClick: () => {
      dispatch({ type: ALLOW_ADDRESS_ROW_CLICK, status: false });
    },
  })
)
class BillingAddressRadio extends PureComponent {
  isChecked() {
    return this.props.index === this.props.billingAddressIndex;
  }

  updateBilling() {
    if (this.isChecked()) {
      return;
    }
    this.props.updateBillingAddress(this.props.index);
  }

  render() {
    return (
      <FormControlLabel
        value={`${this.props.index}`}
        control={
          <Radio
            color="primary"
            checked={this.isChecked()}
            onChange={(event, checked) => {
              this.updateBilling();
            }}
            value={`${this.props.index}`}
            onFocus={(event) => {
              this.props.disableRowClick();
            }}
          />
        }
        label="Billing address"
      />
    );
  }
}
